import * as Sentry from '@sentry/remix'
import { RemixBrowser, useLocation, useMatches } from '@remix-run/react'
import { startTransition, StrictMode, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { initializeClientI18n } from './utils/i18n.client'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://1b8370a1c2f6d4cb3126697e3b807d93@o1160080.ingest.sentry.io/4506603160469504',
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,

    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.remixRouterInstrumentation(
          useEffect,
          useLocation,
          useMatches
        ),
      }),
      new Sentry.Replay(),
    ],
  })
}

// Initialize i18n for client-side hydration
initializeClientI18n()

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  )
})
